module["exports"] = [
  "(Persero) Tbk",
  "Tbk"
];


//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/id_ID/company/suffix.js
// module id = 1213
// module chunks = 1